import { forwardRef } from "react";
import { cn } from "../lib/utils";

export const GoldButton = forwardRef(function GoldButton(
  { className, children, disabled, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      disabled={disabled}
      className={cn(
        "group relative inline-flex items-center justify-center gap-2",
        "rounded-full px-6 py-2.5 text-sm font-semibold tracking-wide",
        "text-[#0a0a0d] bg-gradient-to-b from-[#F4D77A] via-[#D4AF37] to-[#A8862B]",
        "shadow-[0_10px_28px_-12px_rgba(212,175,55,0.7)]",
        "border border-[#D4AF37]/60",
        "transition-transform duration-200 ease-out",
        "hover:scale-[1.015] hover:shadow-[0_14px_36px_-12px_rgba(212,175,55,0.85)]",
        "active:scale-[0.99]",
        "disabled:opacity-50 disabled:hover:scale-100 disabled:cursor-not-allowed",
        className,
      )}
      {...props}
    >
      <span className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-[radial-gradient(120%_60%_at_50%_0%,rgba(255,255,255,0.55),transparent_60%)]" />
      <span className="relative">{children}</span>
    </button>
  );
});

export default GoldButton;
